import { X } from 'lucide-react'

import { cn } from '@/utils'
import type { FilterChipProps } from './types'

export function FilterChip({
  label,
  onRemove,
  onClick,
  className,
}: FilterChipProps) {
  return (
    <div
      className={cn(
        'flex items-center gap-1 bg-blue-2 border border-blue-4 text-blue-7 text-xs font-medium px-2 py-1 rounded-md',
        className,
      )}
    >
      <button
        type="button"
        className="cursor-pointer hover:bg-blue-3 rounded-sm px-1 bg-transparent border-none font-medium text-inherit"
        onClick={onClick}
      >
        {label}
      </button>
      <button
        type="button"
        className="flex items-center justify-center h-3 w-3 rounded-sm hover:bg-blue-4 cursor-pointer"
        onClick={onRemove}
      >
        <X className="h-2.5 w-2.5" />
      </button>
    </div>
  )
}
